import { useSearchParams } from 'react-router-dom'

export type ApiQueryParams = { filters: { name: string; content: UrlFilter }[] }

export type UrlFilter = {
    type: '$in'
    value: string[]
}

export function useUrlFilter(filterName: string): {
    filter: UrlFilter | null
    setFilter: (newFilter: UrlFilter) => void
} {
    const [searchParams, setSearchParams] = useSearchParams()

    function getCurrentFilter(): UrlFilter | null {
        const currentRawValue = searchParams.get(`filter.${filterName}`) ?? ''
        const split = currentRawValue.split(':')
        const currentFilterType = (split[0] ?? '') as UrlFilter['type']
        const currentFilterValue = split[1] ?? ''

        if (currentFilterType === '$in') {
            return {
                type: '$in',
                value: currentFilterValue.split(',')
            }
        }

        return null
    }

    const filter = getCurrentFilter()

    function setFilter(newFilter: UrlFilter) {
        const newParams = new URLSearchParams(searchParams)
        const filterKey = `filter.${filterName}`

        if (newFilter.type === '$in') {
            if (newFilter.value.length === 0) {
                newParams.delete(filterKey)
            } else {
                newParams.set(filterKey, `$in:${newFilter.value.join(',')}`)
            }
        }

        setSearchParams(newParams)
    }

    return {
        filter,
        setFilter
    }
}
